<template>
  <div class="relative pb-4 mb-6">
    <vs-card>
      <div class="vx-row">
        <div class="vx-col w-full flex justify-between">
          <slot name="header"></slot>
        </div>
        <div class="vx-col w-full lg:flex lg:justify-between">
          <slot name="body"></slot>
        </div>

        <template v-if="expand">
          <transition name="slide">
            <div v-if="expandDetails" class="vx-col w-full">
              <div class="w-full flex justify-center mb-3">
                <hr class="hrDetalhes mt-2" />
              </div>
              <div class="sm:flex w-full mt-3">
                <slot name="details"></slot>
              </div>
            </div>
          </transition>
        </template>
      </div>
    </vs-card>

    <div v-if="expand" class="expandirCotacoes vx-col">
      <vs-button
        color="#E9E9E9"
        text-color="#374957"
        :icon="expandDetails ? 'expand_less' : 'expand_more'"
        icon-after
        class="w-full buttonExpandirCotacoes z-0 text-base font-semibold"
        @click="expandDetails = !expandDetails"
      >
        {{ expandDetails ? 'Recolher' : 'Expandir' }}
      </vs-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['expand'],
  data() {
    return {
      expandDetails: false,
    };
  },
};
</script>
